<script lang="ts">
  /**
   * Minimal footer — 3-column grid that stacks on mobile.
   * Pure monochrome, no dividers beyond the top border-subtle.
   */
  import LogoIcon from './LogoIcon.svelte';

  const year = new Date().getFullYear();

  const productLinks = [
    { href: '/search',  label: 'Іздеу' },
    { href: '/reading', label: 'Оқу' },
    { href: '/learn',   label: 'Үйрену' },
    { href: '/test',    label: 'Тест' },
    { href: '/about',   label: 'Біз туралы' }
  ];

  const socialLinks = [
    { href: 'https://t.me/zetix_online',               label: 'Telegram' },
    { href: 'https://www.instagram.com/zetix_online/', label: 'Instagram' },
    { href: 'mailto:hi@zetix.kz',                      label: 'hi@zetix.kz' }
  ];

  const legalLinks = [
    { href: '/privacy', label: 'Құпиялылық' },
    { href: '/terms',   label: 'Шарттар' }
  ];
</script>

<footer class="footer">
  <div class="container">
    <div class="grid">
      <div class="brand">
        <a href="/" class="brand-logo" aria-label="Zetix — басты бет">
          <LogoIcon size={20} />
          <span>Zetix</span>
        </a>
        <p class="tagline">ҰБТ-ға дайындық платформасы</p>
      </div>

      <nav class="links" aria-label="Өнім сілтемелері">
        <div class="col-title">Өнім</div>
        {#each productLinks as link (link.href)}
          <a href={link.href} class="link">{link.label}</a>
        {/each}
      </nav>

      <nav class="links" aria-label="Байланыс">
        <div class="col-title">Байланыс</div>
        {#each socialLinks as link (link.href)}
          <a
            href={link.href}
            class="link"
            target={link.href.startsWith('http') ? '_blank' : undefined}
            rel={link.href.startsWith('http') ? 'noopener noreferrer' : undefined}
          >
            {link.label}
          </a>
        {/each}
      </nav>
    </div>

    <div class="bottom">
      <span>© {year} Zetix</span>
      <span class="bottom-legal">
        {#each legalLinks as link, i (link.href)}
          {#if i > 0}<span class="dot">·</span>{/if}
          <a href={link.href} class="link">{link.label}</a>
        {/each}
      </span>
      <span class="made">Made in Kazakhstan</span>
    </div>
  </div>
</footer>

<style>
  .footer {
    background: var(--color-bg-subtle);
    color: var(--color-fg-secondary);
    padding: var(--space-12) 0 var(--space-8);
    border-top: 1px solid var(--color-border-subtle);
  }
  .container {
    max-width: var(--container-max);
    margin: 0 auto;
    padding: 0 var(--space-4);
  }
  .grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: var(--space-8);
  }
  @media (min-width: 768px) {
    .grid { grid-template-columns: 1.5fr 1fr 1fr; }
  }

  .brand {
    display: flex;
    flex-direction: column;
    gap: var(--space-3);
  }
  .brand-logo {
    display: inline-flex;
    align-items: center;
    gap: var(--space-2);
    color: var(--color-fg);
    font-size: var(--text-base);
    font-weight: var(--fw-semibold);
    width: fit-content;
  }
  .tagline {
    font-size: var(--text-sm);
    color: var(--color-fg-secondary);
    line-height: var(--leading-normal);
    max-width: 28ch;
  }

  .links {
    display: flex;
    flex-direction: column;
    gap: var(--space-2);
  }
  .col-title {
    font-size: var(--text-xs);
    font-weight: var(--fw-medium);
    color: var(--color-fg-muted);
    text-transform: uppercase;
    letter-spacing: 0.04em;
    margin-bottom: var(--space-1);
  }
  .link {
    font-size: var(--text-sm);
    color: var(--color-fg-secondary);
    width: fit-content;
    transition: color var(--dur-fast) var(--ease);
  }
  .link:hover { color: var(--color-fg); }

  .bottom {
    margin-top: var(--space-10);
    padding-top: var(--space-6);
    border-top: 1px solid var(--color-border-subtle);
    display: flex;
    flex-wrap: wrap;
    gap: var(--space-3) var(--space-4);
    align-items: center;
    justify-content: space-between;
    font-size: var(--text-xs);
    color: var(--color-fg-muted);
  }
  .bottom-legal {
    display: inline-flex;
    gap: var(--space-2);
    align-items: center;
  }
  .bottom-legal .link { font-size: var(--text-xs); color: var(--color-fg-muted); }
  .bottom-legal .link:hover { color: var(--color-fg-secondary); }
  .dot { color: var(--color-fg-subtle); }
  .made { font-variant-numeric: tabular-nums; }

  @media (prefers-reduced-motion: reduce) {
    .link { transition: none !important; }
  }
</style>
